import { default as mountMenuItems } from './mountMenuItems'
import { default as isPmo } from './isPmo'
import { default as isResponsable } from './isResponsable'

export default {
  mountMenuItems,
  isPmo,
  isResponsable,
}
